import Framework from 'framework';
import { proxyToClubStore } from './proxyToEnterpriseFramework';

function defaultData() {
	return {
		club: {
			country: '',
			id: '',
			clubTypeId: null,
			domainPrefix: '',
			street: '',
			city: '',
			state: '',
			stateName: '',
			zip: '',
			region: '',
			area: '',
			timeZone: '',
			membershipLevel: '',
			status: '',
			openDate: '',
			latitude: '',
			longitude: '',
			name: '',
			description: '',
			phone: '',
			nearestClubCacheLastLoaded: '',
			link: '',
			prospectPageLink: '',
			clubPagePaths: '',
			isClubPage: false,
			navHtml: '',
			juniorAccess: ''
		},
		initialized: false
	};
}

function updateClubDataFromObject(clubData, club){
	const output = Object.assign({}, clubData);

	output.country = club.country || '';
	output.id = club.id;
	output.clubTypeId = club.clubTypeId;
	output.domainPrefix = club.domainPrefix || '';
	output.street = club.street1 || '';
	output.city = club.city || '';
	output.state = club.state || '';
	output.stateName = club.stateName || '';
	output.zip = club.zip || '';
	output.region = club.region || '';
	output.area = club.area || '';
	output.timeZone = club.timeZone || '';
	output.membershipLevel = club.membershipLevel || '';
	output.juniorAccess = club.juniorAccess || '';
	output.status = club.status || '';
	output.openDate = club.openDate || '';
	output.latitude = club.latitude;
	output.longitude = club.longitude;
	output.name = club.name || '';
	output.description = club.description || '';
	output.phone = club.phone || '';
	output.link = club.link || window.location.href;

	output.isClubPage = Boolean(clubData.name);

	return output;
}

function currentData() {
	return proxyToClubStore('getInitialData', defaultData())();
}

const ClubStore = {
	name: 'ClubStore',

	// The `enterprise-framework` clubStore has an object with `club` and `initialized` in it
	// but existing lt-aem callers expect to get just `club`, or just `initialized`.
	getInitialData: () => currentData().club,
	initialized: () => currentData().initialized,
	initialize: proxyToClubStore('initialize'),
	listen: (callback) => proxyToClubStore('listen')((state) => callback((state || {}).club)),
	initializeClub: (club) => club
		? proxyToClubStore('initializeClub')(updateClubDataFromObject(defaultData().club, club))
		: proxyToClubStore('initializeClub')(),
	updateClub: (updatedClub) => proxyToClubStore('updateClub')(updateClubDataFromObject(currentData().club, updatedClub))
};

Framework.registerStore(ClubStore.name, ClubStore);

export default ClubStore;
